import { motion } from "framer-motion";
import React from "react";
import { adds } from "../../../assets";
import Button from "../../../components/Button";
import "./index.css";

const Ingresos = ({ variants }) => {
  return (
    <div className="ingresos section relative">
      <img className="blur blur1" src={adds.blur1} alt="Blur" />

      <div className="container-lg flex flexCol alignCenter textCenter">
        <motion.h5
          variants={variants}
          initial={"initial"}
          whileInView={"ani"}
          viewport={{ once: true }}
          custom={0.3}
        >
          Servicios
        </motion.h5>
        <motion.h2
          variants={variants}
          initial={"initial"}
          whileInView={"ani"}
          viewport={{ once: true }}
          custom={0.6}
        >
          Impulsá tu negocio
        </motion.h2>
        <motion.p
          variants={variants}
          initial={"initial"}
          whileInView={"ani"}
          viewport={{ once: true }}
          custom={0.9}
          className="parDes"
        >
          Aplicá Big Data o Data Science para crear sistemas automatizados que
          maximicen sus ingresos, o bien, podés elegir el servicio que mejor se
          acomode a lo que buscás
        </motion.p>
        <Button
          color={"white"}
          text={"Ver servicios"}
          href={"/servicios"}
          type={"link"}
          variants={variants}
          delay={1.2}
        />
      </div>
    </div>
  );
};

export default Ingresos;
